import { SoForm, SoFormItem, SoLocation } from "../models/SoFormModels";

export default class SoScreenState {
    soForms: SoForm[] = [];
    soFormItems: SoFormItem[] = [];
    soLocations?: SoLocation[] = [];
    selectedForm?: number;
    selectedLocationId?: number;
    selectedLocation?: string;          // name of the selected location
}